
class CommonUtility {

    /**
     * Check if given argument have 8 digits contain at least 1 uppercase, 1 lowercase, 
     * 1 numbers, and 1 special characters. (combination of any THREE (3) of the FOUR (4) listed is acceptable
     * @param {String} password password to check
     * @returns {Boolean} 
     */
    isValidPasswordFormat(password) {

        if (!password) return false;

        // must contain at least 1 lowercase alphabetical character
        let regexLowercase = new RegExp("^(?=.*[a-z])");

        // must contain at least 1 uppercase alphabetical character
        let regexUppercase = new RegExp("^(?=.*[A-Z])");

        // must contain at least 1 numeric character
        let regexNumber = new RegExp("^(?=.*[0-9])");

        // must contain at least one special character
        let regexSymbol = new RegExp(/[-!@#$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/);

        // must be eight characters or longer
        let regexGreaterThan8 = new RegExp("^(?=.{8,30})");

        let isContainLowercase = regexLowercase.test(password);
        let isContainUppercase = regexUppercase.test(password);
        let isContainNumber = regexNumber.test(password);
        let isContainSymbol = regexSymbol.test(password);
        let isRegexGreaterThan8 = regexGreaterThan8.test(password);

        let totalValid = 0;
        if(isContainLowercase) totalValid += 1;
        if(isContainUppercase) totalValid += 1;
        if(isContainNumber) totalValid += 1;
        if(isContainSymbol) totalValid += 1;

        return (totalValid >= 3 ) && isRegexGreaterThan8;

    }

    haveUserType( userType, userData ){
        if(!userType || !userData) return false;

        if(userData.userType === userType)
            return true;
        else 
            return false;
    }

    haveRoles( rolesArray, userData ){
        if(!Array.isArray(rolesArray) || !userData) return false;

        let exist = userData.roles.some( role => rolesArray.includes(role.type) );
        return exist ? true : false;
    }

    haveEmptyRoles(userData){
        if(!userData) return false;
        if(!Array.isArray(userData.roles)) return true;
        if(userData.roles.length === 0) return true;
    
        return false;
    }

    maskString = function(sentence = "", {unmaskedPattern, endCount, beginCount, mask} = {endCount: 2, beginCount: 1, mask: "*"}){
        if(unmaskedPattern){
          [endCount, beginCount] = unmaskedPattern.split(',').map(e=>parseInt(e)).reverse();
        }
        if(!endCount){
          endCount = 0;
        }
        if(!beginCount){
          beginCount = 0;
        }
        if(!mask){
          mask = '*';
        }
        if(sentence.length <= (beginCount + endCount)) return sentence;
        const masked = sentence.replace(/[a-zA-Z0-9_.-]/g, mask);
        return sentence.substr(0, beginCount) + masked.substr(beginCount, masked.length - (beginCount + endCount)) + sentence.substr(sentence.length-endCount)
      }

}

export default new CommonUtility();